import React, { useEffect, useContext, useState, useRef } from 'react';

import { Progress } from '@/components/ui/progressbar';
import { CartContext } from '@/contexts/CartContext';

interface FreeShippingNoticeProps {
    name?: string;
}
export const FreeShippingNotice = ({ name }: FreeShippingNoticeProps) => {
    const freeShippingThresholdNumber = Number(window?.tscConfig?.FreeShippingThreshold);
    const { cartData: cart } = useContext(CartContext);
    useEffect(() => {}, []);
    const [delayedPercentage, setDelayedPercentage] = useState(0);
    const isAutoFreeShipApplied = cart?.OrderSummary?.IsAutoFreeShipApplied;
    const isRogersCCFreeShipApplied = cart?.OrderSummary?.IsRogersCCFreeShipApplied;
    const autoFreeShipAwayFromThresholdAmount = Number(cart?.OrderSummary?.AutoFreeShipAwayFromThresholdAmount);
    const difference =
        autoFreeShipAwayFromThresholdAmount == 0
            ? 0
            : freeShippingThresholdNumber - autoFreeShipAwayFromThresholdAmount;
    const percentage = Math.min(Math.round((difference / freeShippingThresholdNumber) * 100), 100);
    const [isOpen, setIsOpen] = useState(false);
    const prevIsOpen = useRef(isOpen);
    const HasRemoteShipTo = cart.HasRemoteShipTo;

    const hasEarnedFreeShipping = isAutoFreeShipApplied || isRogersCCFreeShipApplied;
    const isNearFreeShippingThreshold = autoFreeShipAwayFromThresholdAmount > 0;
    const canShowShippingNotice = !HasRemoteShipTo;

    // Set isOpen to true after the component initially loads
    useEffect(() => {
        setIsOpen(true);
    }, []);

    useEffect(() => {
        let timer;
        if (prevIsOpen.current === false && isOpen === true) {
            //delayed open
            timer = setTimeout(() => {
                setDelayedPercentage(percentage);
            }, 600);
        } else {
            setDelayedPercentage(percentage);
        }
        prevIsOpen.current = isOpen;
        // Cleanup function to clear the timer
        return () => clearTimeout(timer);
    }, [isOpen, percentage]);

    // *note*
    // because checkout does not use tailwind yet we include inline styles
    // tailwind classes will be ignored until new checkout is implemented

    const FreeShippingEarned = () => (
        <div
            style={{
                textAlign: 'center',
                fontSize: '0.75rem',
                lineHeight: '17px',
                minHeight: '34px',
                marginTop: '10px',
                alignContent: 'center',
                padding: '0 3px',
            }}
        >
            {isRogersCCFreeShipApplied ? (
                <>
                    You&apos;ve earned <b>FREE standard shipping </b> with{' '}
                    <b style={{ whiteSpace: 'nowrap' }}>Rogers Bank Mastercard!</b>
                </>
            ) : (
                <>
                    You&apos;ve earned <b>FREE standard shipping! </b>
                </>
            )}
        </div>
    );

    const FreeShippingProgress = () => (
        <div
            style={{
                textAlign: 'center',
                fontSize: '0.75rem',
                lineHeight: '17px',
                minHeight: '34px',
                marginTop: '10px',
                alignContent: 'center',
            }}
            className="freeshipping_text"
        >
            <span>
                You&apos;re <b>{cart?.OrderSummary?.AutoFreeShipAwayFromThreshold}</b> from{' '}
            </span>
            <span>
                <b>
                    FREE standard shipping on{' '}
                    <a
                        href="/pages/customer-service/shipping-handling"
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: 'underline', color: '#000', whiteSpace: 'nowrap' }}
                        className="!underline"
                    >
                        eligible items
                    </a>
                </b>
            </span>
        </div>
    );

    return (
        <>
            {canShowShippingNotice &&
                (hasEarnedFreeShipping ? (
                    <FreeShippingEarned />
                ) : isNearFreeShippingThreshold ? (
                    <FreeShippingProgress />
                ) : null)}
        </>
    );
};
